import { connect } from 'react-redux'
import Trips from '../../components/trips/Trips'
import { IStoreState } from '../../types'
import { showOrgServiceArea, actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import { mapViewStrategyStages } from '../../components/MapView'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  return {
    value: state.riderSearch.query,
    location: ownProps.location
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    setCurrentTripStage: () => dispatch(mapsActionCreators.setMapViewStrategyStage(mapViewStrategyStages.showInit)),
    showOrgServiceArea: () => dispatch(showOrgServiceArea)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Trips)



// WEBPACK FOOTER //
// ./src/containers/trips/Trips.ts